import styled from "@emotion/styled";

export const StyledCell = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  text-align: left;
  font-size: ${p => p.theme.fontSizes.m};
  font-weight: ${p => p.theme.fontWeight.medium};
  color: ${p =>
    !p.red ? p.theme.colors.secondary.gray : p.theme.colors.error.main};

  border-bottom: ${p => p.theme.borders.browserInfoTable};

  word-break: break-all;
`;
